var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6a92c5",
    d: "M6.562,66.74H5.25V64.448a.46.46,0,0,0-.279-.428.426.426,0,0,0-.482.12L.114,69.182a.475.475,0,0,0,0,.616l4.375,5.042a.426.426,0,0,0,.482.12.46.46,0,0,0,.279-.428V72.24H6.467a10.189,10.189,0,0,1,6.811,2.64.421.421,0,0,0,.467.068A.458.458,0,0,0,14,74.531,7.629,7.629,0,0,0,6.562,66.74Zm-.1,4.583H4.812a.448.448,0,0,0-.438.458v1.565L1.029,69.49l3.346-3.856V67.2a.448.448,0,0,0,.438.458h1.75a6.374,6.374,0,0,1,4.64,2.013,6.946,6.946,0,0,1,1.854,3.865A11.006,11.006,0,0,0,6.467,71.323Z",
    transform: "translate(0 -63.99)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.adaa87f2.svg";
export { ForwardRef as ReactComponent };